import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { projectManagerGuard } from './guards/project-manager.guard';
import { SignInComponent } from './pages/unauthenticated/sign-in/sign-in.component';
import { ProjectsComponent } from './pages/authenticated/projects/projects.component';
import { TimesheetsComponent } from './pages/authenticated/timesheets/timesheets.component';
import { ZohoBooksComponent } from './pages/authenticated/zoho-books/zoho-books.component';
import { PageNotFoundComponent } from './pages/unauthenticated/page-not-found/page-not-found.component';
import { RoutesConstants } from './constants/routes.constants';
import { UnauthorizedComponent } from './pages/unauthenticated/unauthorized/unauthorized.component';
import { ZohoCallbackComponent } from './pages/unauthenticated/zoho-callback/zoho-callback.component';
import { ZohoSetupComponent } from './pages/authenticated/zoho-setup/zoho-setup.component';
import { BcSyncComponent } from './pages/authenticated/bc-sync/bc-sync.component';

export const routes: Routes = [
  {
    path: '',
    component: ProjectsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutesConstants.SIGN_IN_URL,
    component: SignInComponent,
  },
  {
    path: RoutesConstants.PROJECTS_URL,
    component: ProjectsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutesConstants.TIMESHEETS_URL,
    component: TimesheetsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutesConstants.ZOHO_BOOKS_URL,
    component: ZohoBooksComponent,
    canActivate: [MsalGuard],
  },
  {
    path: RoutesConstants.ZOHO_SETUP_URL,
    component: ZohoSetupComponent,
    canActivate: [MsalGuard, projectManagerGuard],
  },
  {
    path: RoutesConstants.BC_SYNC_URL,
    component: BcSyncComponent,
    canActivate: [MsalGuard, projectManagerGuard],
  },
  {
    path: RoutesConstants.ZOHO_CALLBACK_URL,
    component: ZohoCallbackComponent,
  },
  {
    path: RoutesConstants.UNAUTHORIZED_URL,
    component: UnauthorizedComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
